import { render, staticRenderFns } from "./group-database.vue?vue&type=template&id=2c79ebc0&"
import script from "./group-database.vue?vue&type=script&lang=js&"
export * from "./group-database.vue?vue&type=script&lang=js&"
import style0 from "./group-database.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports